import { TZDate } from '@date-fns/tz';
import { t } from '@lingui/core/macro';
import { TireHotelScheduledBookingRecord, WheelStorageCommercialFamily } from '@navio/nsdk';
import { NoddiLink } from 'noddi-ui-web';
import { BookingDetailsTabs, CustomDateFormats, customerRoutes, NoddiDateFormats, noddiFormatDate } from 'noddi-util';

const titleByFamily = (): Record<WheelStorageCommercialFamily, string> => ({
  [WheelStorageCommercialFamily.NEW]: t`Tire hotel signup booked`,
  [WheelStorageCommercialFamily.RENEW]: t`Tire hotel renewal booked`,
  [WheelStorageCommercialFamily.CANCEL]: t`Tire hotel ending booked`
});

type Props = {
  scheduledBooking: TireHotelScheduledBookingRecord;
};

export const ScheduledTireHotelBooking = ({ scheduledBooking }: Props) => {
  const { slug, timeZone, deliveryWindowStartsAt, deliveryWindowEndsAt, commercialFamily } = scheduledBooking;
  const date = noddiFormatDate(
    new TZDate(deliveryWindowStartsAt, timeZone),
    CustomDateFormats.FULL_WEEKDAY_DAY_DOT_MONTH
  );
  const timeWindow = `${noddiFormatDate(new TZDate(deliveryWindowStartsAt, timeZone), NoddiDateFormats.TIME)}–${noddiFormatDate(new TZDate(deliveryWindowEndsAt, timeZone), NoddiDateFormats.TIME)}`;

  return (
    <div className='flex flex-col gap-2 border-t border-border pt-4'>
      <div className='flex min-w-0 flex-col gap-1'>
        <span className='text-sm font-medium text-darkPurple70'>{titleByFamily()[commercialFamily]}</span>
        <span className='font-semibold first-letter:uppercase'>
          {date}, {timeWindow}
        </span>
      </div>
      <NoddiLink
        to={customerRoutes.bookingInfo.getPath({ slug, tab: BookingDetailsTabs.ORDER_DETAILS })}
        variant='link'
        size='small'
        endIcon='ArrowRight'
        className='-mr-4 -mb-2 self-end'
      >
        {t`See booking`}
      </NoddiLink>
    </div>
  );
};
